import { render, staticRenderFns } from "./ProductTagMini.vue?vue&type=template&id=0d44e368&"
import script from "./ProductTagMini.vue?vue&type=script&lang=js&"
export * from "./ProductTagMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports